const Constants = {
  API_URl_PREFIX: 'api/v1',
  AUTH_LOCAL_STORAGE: 'auth',
  DEFAULT_FALLBACK_IMAGE_PATH: '/assets/svg/photo-placeholder.svg',
  DEFAULT_FALLBACK_PDF_PATH: '/assets/png/PDF_Fallback.png',
  REDIRECT_TO_LOCAL_STORAGE: 'redirectTo',
  TOKEN_LOCAL_STORAGE: 'token',
  groupRoles: {
    ADMIN: 'ADMIN',
    EMPLOYEE: 'EMPLOYEE',
    CUSTOMER: 'CUSTOMER',
    PARTNER_BROKER: 'PARTNER_BROKER',
    CAPTADOR_PARCEIRO: 'CAPTADOR_PARCEIRO'
  },
  GROUP_ROLE: {
    ADMIN: 'ADMIN',
    EMPLOYEE: 'EMPLOYEE',
    CUSTOMER: 'CUSTOMER',
    PARTNER_BROKER: 'PARTNER_BROKER',
    CAPTADOR: 'CAPTADOR',
    CAPTADOR_PARCEIRO: 'CAPTADOR_PARCEIRO'
  },
  // Logo da Corretto para fundo claro: fallback de quem nao tem logo da
  // imobiliaria (assinatura, portal)
  IMAGE_MENU: '/assets/brand/logo-horizontal-cor.svg',
  // Titulo da aba no painel e nas telas da plataforma. Igual ao <title> do
  // public/index.html
  PLATFORM_TITLE: 'Corretto · Gestão Imobiliária'
}

export default Constants
